// extracted by mini-css-extract-plugin
export default {"container":"StatisticBox_container__OqXnA","wrapper":"StatisticBox_wrapper__Kb2vL"};